<template>
  <div padding="1em">
    <div id="app">
    <router-view/>
  </div>
  <div class="x_footer">
    <a href="http://www.bicg.com" target="_blank" rel="noopener noreferrer">
      <img src="./assets/bicg-logo.png" alt="BICG-logo">
    </a>
    <p style="color: #7A9DB1;">&copy; BICG 2018 | <a href="https://www.bicg.com" target="_blank" style="color: #7A9DB1; text-decoration: none !important;">www.bicg.com</a></p>
  </div>
  </div>
</template>

<script>

export default {
  name: 'App'

}
</script>

<style>
body {
  margin: 0px;
  background-color: #17445F;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100%;
  padding-bottom:60px;
}
.x_footer {
  padding: 2em !important;
  background-color: #17445F;
  text-align: center;
  margin: 0px auto;
  font-size: 10px;
  position: fixed;
  bottom: 0;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue